import { resetSchoolDataCacheSyncState } from './schoolDataCacheVersion';

/** 로그인·새로고침 직후 학교 스코프(연간·프로그램) 버전 재동기화를 트리거 */

export const SCHOOL_DATA_LOGIN_HEAD_SYNC_EVENT = 'cp-school-data-login-head-sync';

let generation = 0;

export function getSchoolDataLoginHeadSyncGeneration(): number {
  return generation;
}

/** in-memory sync 가드 해제 + keep-alive 페이지가 다시 `syncSchoolCachesWithQuery` 돌리도록 이벤트 */
export function markSchoolDataLoginHeadSyncPending(workspaceId?: string | null): void {
  generation += 1;
  resetSchoolDataCacheSyncState(workspaceId?.trim() || undefined);
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(SCHOOL_DATA_LOGIN_HEAD_SYNC_EVENT, { detail: { generation } })
  );
}
